module.exports = __webpack_public_path__ + "static/media/cross.1c46d242.svg";